import { request } from "./authApi";

// Public: no token needed, matches the backend's Section A /search route.
export function search(query) {
  return request(`/search?q=${encodeURIComponent(query)}`);
}
